import { useEffect } from 'react';

import useToast from 'contexts/ToastProvider/useToast';
import { isInviteNotificationToastId } from 'modules/Notifications/inviteNotificationIds';
import useSingleTabContext from 'modules/SingleTabGuard/useSingleTabContext';

const InviteNotificationsTabGuard = () => {
  const { isMainTab } = useSingleTabContext();
  const { toastState, removeToast } = useToast();

  useEffect(() => {
    if (isMainTab) return;

    toastState.forEach((toast) => {
      if (isInviteNotificationToastId(toast.id)) removeToast(toast.id);
    });
  }, [isMainTab, toastState, removeToast]);

  return null;
};

export default InviteNotificationsTabGuard;
